export const MAX_DOCS_WARNING =
  "Looks like you’ve hit the max! You can upload up to 10 documents.";

export function inferMimeType(fileName?: string): string {
  if (!fileName) return "application/octet-stream";

  const ext = fileName.split(".").pop()?.toLowerCase();

  switch (ext) {
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "gif":
      return "image/gif";
    case "webp":
      return "image/webp";
    case "pdf":
      return "application/pdf";
    default:
      return "application/octet-stream";
  }
}

